import React from 'react';

export function FAQ() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-8">Frequently Asked Questions</h1>
      
      <div className="space-y-8">
        <div>
          <h2 className="text-xl font-semibold mb-3">What is dittowalletbot?</h2>
          <p className="text-gray-600">
            @dittowalletbot is a friendly AI companion on X (formerly Twitter) that helps users manage their cryptocurrency wallets. 
            It assists users with transactions (swaps, sends) on Base and Solana Networks using pre-generated wallets. Users can 
            interact with their wallets simply by tagging @dittowalletbot in their posts.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-3">How is my wallet generated?</h2>
          <p className="text-gray-600">
            Your wallets are pre-generated for your X account upon your first interaction with @dittowalletbot. 
            Each user gets dedicated wallets on both Base and Solana networks. These wallets are automatically 
            created and linked to your X identity, requiring no manual setup process.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-3">How is my wallet secured?</h2>
          <p className="text-gray-600">
            Your wallets are securely custodied by Privy, a trusted wallet infrastructure provider. Neither 
            dittowalletbot nor the dittowalletbot development team has access to the private keys or seed 
            phrases of your wallets. Think of this as an escrow system where your funds are securely held 
            and can be withdrawn to any external wallet at any time.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-3">How is the PIPPIN framework utilized by dittowalletbot?</h2>
          <p className="text-gray-600">
            The PIPPIN framework is used by dittowalletbot to post thoughts and adventures in its timeline 
            through a separate process from user interactions. This allows dittowalletbot to maintain an 
            engaging presence on X while efficiently and securely handling user requests for wallet operations.
          </p>
        </div>
      </div>
    </div>
  );
} 